export default __webpack_public_path__ + "static/media/star_wars.24859090.jpeg";